export default __webpack_public_path__ + "static/media/world.c5ba939b.png";